(function ($, v, util) {
    $.fn.printbutton = function( query, post, onerror, onsuccess ) {
            
            return this.each(function () {

                const $me = $(this);
				const $downloadButton = $me.find('.cmdDownload');
				const $printButton = $me.find('.cmdPrint');

	        	const settings = {
	        		'query': query,
					'post': post,
					'onerror': onerror || function(xhr, textStatus, error){ alert("Fehler bei der Kommunikation mit dem Server."); }
				};

	        	if(settings.query !== null) $me.data('query', settings.query);

				$printButton.click( function() {
					$downloadButton.hide();
				});

				$printButton.loadbutton($me.data('query'), settings.post, function(data) {
					if(data.pdffile) {
						$downloadButton.data("href", data.pdffile);
						$downloadButton.css('display', 'inline-block');
						$printButton.addClass('printSuccess');
						if(onsuccess) {
							onsuccess.call($printButton, data);
						}
					}
				}, settings.onerror);

				$downloadButton.click( function(event) {
					event.preventDefault();
					const downloadUrl = $(this).data('href');
					if(downloadUrl) {
						if(util.strEndsWith(downloadUrl, 'pdf')) {
							window.open(downloadUrl, '_blank');
						} else {
							window.open(downloadUrl, '_top');
						}
					}
				});

            });
        };

	$.fn.printAndSignButton = function( query, querysign, post, onerror, onsignsuccess ) {

		return this.each(function () {

			const $me = $(this);
			const $printButton = $me.find('.cmdPrint');
			const $downloadButton = $me.find('.cmdDownload');
			const $signButton = $me.find('.cmdSign');
			const $signFolderButton = $me.find('.cmdSignFolder');

			const settings = {
				'query': query,
				'querysign': querysign,
				'post': post,
				'onerror': onerror || function(xhr, textStatus, error){ alert("Fehler bei der Kommunikation mit dem Server."); },
				'onsignsuccess': onsignsuccess || null
			};

			if(settings.query !== null) $me.data('query', settings.query);
			if(settings.querysign !== null) $me.data('querysign', settings.querysign);

			$printButton.click( function() {
				$downloadButton.hide();
				$signButton.hide();
				$signFolderButton.hide();
			});

			$printButton.loadbutton($me.data('query'), settings.post, function(data) {
				if(data.pdffile) {
					$downloadButton.data("href", data.pdffile);
					$downloadButton.css('display', 'inline-block');
					$signButton.css('display', 'inline-block');
					$printButton.addClass('printSuccess');
				}
			}, onerror);

			$signButton.loadbutton($me.data('querysign'), settings.post, function(data) {
				if(data.pdffile) {
					$signFolderButton.data("href", data.pdffile);
					$signFolderButton.css('display', 'inline-block');
				}
				if(data.success && !validationaware.hasErrors(data)) {
					$signButton.hide();
					$printButton.addClass('signSuccess');
					if(settings.onsignsuccess != null) {
						settings.onsignsuccess.call($me, data);
					}
				}
			}, onerror);

			$downloadButton.click( function(event) {
				event.preventDefault();
				const downloadUrl = $(this).data('href');
				if(downloadUrl) {
					if(util.strEndsWith(downloadUrl, 'pdf')) {
						window.open(downloadUrl, '_blank');
					} else {
						window.open(downloadUrl, '_top');
					}
				}
			});

			$signFolderButton.click( function(event) {
				event.preventDefault();
				const downloadUrl = $(this).data('href');
				if(downloadUrl) {
					window.open(downloadUrl, '_top');
				}
			});

		});
	};

	$.fn.printAndSendButton = function( query, querysend, post, onerror, onsendsuccess, onloadsend ) {

		return this.each(function () {

			const $me = $(this);
			const $printButton = $me.find('.cmdPrint');
			const $downloadButton = $me.find('.cmdDownload');
			const $sendButton = $me.find('.cmdSend');

			const settings = {
				'query': query,
				'querysend': querysend,
				'post': post,
				'onerror': onerror || function(xhr, textStatus, error){ alert("Fehler bei der Kommunikation mit dem Server."); },
				'onsendsuccess': onsendsuccess || null,
				'onloadsend': onloadsend || null
			};

			if(settings.query !== null) $me.data('query', settings.query);
			if(settings.queryend !== null) $me.data('querysend', settings.querysend);

			$printButton.click( function() {
				$downloadButton.hide();
				$sendButton.removeAttr("data-fileid");
				$sendButton.hide();
			});

			$printButton.loadbutton($me.data('query'), settings.post, function(data) {
				if(data.pdffile) {
					$downloadButton.data("href", data.pdffile);
					$downloadButton.css('display', 'inline-block');
					$sendButton.css('display', 'inline-block');
					$printButton.addClass('printSuccess');
					$sendButton.attr("data-fileid", data.fileId);
				}
			}, onerror);

			$sendButton.click(function (event) {
				event.preventDefault();
				let $post = $(settings.post).serialize();
				$post += "&fileId=" + $(this).data("fileid");
				openDynamicModalXl($me.data('querysend'), $post, onloadsend);
			});

			$downloadButton.click( function(event) {
				event.preventDefault();
				const downloadUrl = $(this).data('href');
				if(downloadUrl) {
					if(util.strEndsWith(downloadUrl, 'pdf')) {
						window.open(downloadUrl, '_blank');
					} else {
						window.open(downloadUrl, '_top');
					}
				}
			});
		});
	}

})(jQuery, validationaware, util);